/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon_service_dbqcs': {
    width: 22,
    height: 21,
    viewBox: '0 0 22 21',
    data: '<defs><path pid="0" d="M23 13v9H1V1h22v12zm-3-3V4H4v6h16zM4 13v6h16v-6H4zm12.5-4.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm0 9a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z" id="svgicon_icon_service_dbqcs_a"/></defs><g transform="translate(-1 -1)" _fill="none" fill-rule="evenodd"><mask id="svgicon_icon_service_dbqcs_b" _fill="#fff"><use xlink:href="#svgicon_icon_service_dbqcs_a"/></mask><use _fill="#000" xlink:href="#svgicon_icon_service_dbqcs_a"/><g mask="url(#svgicon_icon_service_dbqcs_b)" _fill="#A156DD"><path pid="1" d="M0 0h24v24H0z"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/components/icons/icon_service_dbqcs.js